"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVersionEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const AppVersionDto_1 = require("./AppVersionDto");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class AppVersionEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, appVersion) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            appType: false,
            dataVersion: false,
            baseBackgroundStyle: false,
            enableStartupSound: false
        };
        this._dependencies = dependencies;
        if (appVersion === undefined) {
            this._dto = new AppVersionDto_1.AppVersionDto();
        }
        else if (appVersion instanceof AppVersionDto_1.AppVersionDto) {
            this._dto = new AppVersionDto_1.AppVersionDto(appVersion);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (appVersion instanceof AppVersionEntity) {
            this._dto = new AppVersionDto_1.AppVersionDto(appVersion._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AppVersionDto_1.AppVersionDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getAppType() {
        return this._dto.appType;
    }
    setAppType(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("appType");
        this._requiredFieldsSetStatus.appType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("appType", "App Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("appType", `App Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.appType) {
            return;
        }
        this._dto.appType = _untrustedValue;
        this._setIsDirty(true);
    }
    getDataVersion() {
        return this._dto.dataVersion;
    }
    setDataVersion(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("dataVersion");
        this._requiredFieldsSetStatus.dataVersion = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("dataVersion", "Data Version is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("dataVersion", `Data Version has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.dataVersion) {
            return;
        }
        this._dto.dataVersion = _untrustedValue;
        this._setIsDirty(true);
    }
    getBaseBackgroundStyle() {
        return this._dto.baseBackgroundStyle;
    }
    setBaseBackgroundStyle(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("baseBackgroundStyle");
        this._requiredFieldsSetStatus.baseBackgroundStyle = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("baseBackgroundStyle", "Base Background Style is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("baseBackgroundStyle", `Base Background Style has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.baseBackgroundStyle) {
            return;
        }
        this._dto.baseBackgroundStyle = _untrustedValue;
        this._setIsDirty(true);
    }
    getShowChooseManufacturerScreen() {
        return this._dto.showChooseManufacturerScreen;
    }
    setShowChooseManufacturerScreen(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("showChooseManufacturerScreen", "Show Choose Manufacturer Screen is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("showChooseManufacturerScreen", "Show Choose Manufacturer Screen is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.showChooseManufacturerScreen) {
            return;
        }
        this.clearError("showChooseManufacturerScreen");
        this._dto.showChooseManufacturerScreen = _untrustedValue;
        this._setIsDirty(true);
    }
    getSourceVersion() {
        return this._dto.sourceVersion;
    }
    setSourceVersion(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("sourceVersion");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("sourceVersion", `Source Version has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.sourceVersion) {
            return;
        }
        this._dto.sourceVersion = _untrustedValue;
        this._setIsDirty(true);
    }
    getMultipleLocationStartupScreen() {
        return this._dto.multipleLocationStartupScreen;
    }
    setMultipleLocationStartupScreen(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("multipleLocationStartupScreen");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("multipleLocationStartupScreen", `Source Version has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.multipleLocationStartupScreen) {
            return;
        }
        this._dto.multipleLocationStartupScreen = _untrustedValue;
        this._setIsDirty(true);
    }
    getEnableStartupSound() {
        return this._dto.enableStartupSound;
    }
    setEnableStartupSound(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("enableStartupSound", "Enable Startup Sound is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("enableStartupSound", "Enable Startup Sound is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue ===
            this._dto.enableStartupSound) {
            return;
        }
        this.clearError("enableStartupSound");
        this._dto.enableStartupSound = _untrustedValue;
        this._setIsDirty(true);
    }
    getChooseLocationStyle() {
        return this._dto.chooseLocationStyle;
    }
    setChooseLocationStyle(untrustedValue) {
        const maxLength = 12;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("chooseLocationStyle");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("chooseLocationStyle", `Choose Location Style has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.chooseLocationStyle) {
            return;
        }
        this._dto.chooseLocationStyle = _untrustedValue;
        this._setIsDirty(true);
    }
    getMenuButtonText() {
        return this._dto.menuButtonText;
    }
    setMenuButtonText(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("menuButtonText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("menuButtonText", `Menu Button Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.menuButtonText) {
            return;
        }
        this._dto.menuButtonText = _untrustedValue;
        this._setIsDirty(true);
    }
    getContactButtonText() {
        return this._dto.contactButtonText;
    }
    setContactButtonText(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("contactButtonText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("contactButtonText", `Contact Button Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.contactButtonText) {
            return;
        }
        this._dto.contactButtonText = _untrustedValue;
        this._setIsDirty(true);
    }
    getLandingScreenNavbarStyle() {
        return this._dto.landingScreenNavbarStyle;
    }
    setLandingScreenNavbarStyle(untrustedValue) {
        const maxLength = 12;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("landingScreenNavbarStyle");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("landingScreenNavbarStyle", `Landing Screen Navbar Style has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.landingScreenNavbarStyle) {
            return;
        }
        this._dto.landingScreenNavbarStyle = _untrustedValue;
        this._setIsDirty(true);
    }
    getInventoryPricingPosition() {
        return this._dto.inventoryPricingPosition;
    }
    setInventoryPricingPosition(untrustedValue) {
        const maxLength = 12;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("inventoryPricingPosition");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("inventoryPricingPosition", `Inventory Pricing Position has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.inventoryPricingPosition) {
            return;
        }
        this._dto.inventoryPricingPosition = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.appVersionDatastore
                    .getAsync(id, expand);
                delete this._appEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("App Version is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.appVersionDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.appVersionDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("App Version cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.appVersionDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AppVersionEntity = AppVersionEntity;
//# sourceMappingURL=AppVersionEntity.js.map